import { type RoutesStateModel } from "./routes.state";

const ACTION_SCOPE = "[Routes]";

export class SetRoutes {
  static readonly type = `${ACTION_SCOPE} Set Routes`;
  constructor(public routes: RoutesStateModel) {}
}
